module.exports = __webpack_public_path__ + "img/cguanbi.e6d96357.png";